export type DeviceComplaintSite = 'lab' | 'dme'

// Mirrors the complaint type checkboxes of the complaint form
export const DEVICE_COMPLAINT_CATEGORIES = [
  { value: 'MALFUNCTION', label: 'Device malfunction or failure' },
  { value: 'INJURY', label: 'Injury or adverse reaction' },
  { value: 'LABELING', label: 'Incorrect labeling or instructions' },
  { value: 'PACKAGING', label: 'Packaging damage or contamination' },
  { value: 'OTHER', label: 'Other' },
]

export const DEVICE_COMPLAINT_STATUSES = [
  { value: 'OPEN', label: 'Open', badgeClass: 'badge-danger' },
  { value: 'IN_REVIEW', label: 'In Review', badgeClass: 'badge-warning' },
  { value: 'CLOSED', label: 'Closed', badgeClass: 'badge-success' },
]

export const DEVICE_COMPLAINT_CLOSED_STATUS = 'CLOSED'

// Complaint form fields filled by the backend from the complaint details
export const DEVICE_COMPLAINT_AUTO_FILLED_FIELD_NAMES = [
  'Description of complaint',
  'Complaint reported by',
  ...DEVICE_COMPLAINT_CATEGORIES.map(({ label }) => label),
]

export const DEVICE_COMPLAINT_DESCRIPTION_MAX_LENGTH = 5000

export const DEVICE_COMPLAINTS_FILTER_PARAM = 'complaints'

export const DEVICE_COMPLAINTS_FILTER_OPTIONS = [
  { value: 'open', label: 'Open complaints' },
  { value: 'any', label: 'Any complaints' },
]

export const DEVICE_COMPLAINTS_MENU_BADGE = { testType: 'DEVICES', bucket: 'DEVICE_COMPLAINTS' }
